module.exports = __webpack_public_path__ + "static/media/scheduler-call-back-desktop.84cbf9cb.png";